import React, { useEffect, useState, useContext } from "react";
import { WplywContext } from "../../../../../context/wplywContext";
import numberFormat from "../../../../../components/numberFormat";

const ProgressBarDeductions = () => {
	const { wplyw } = useContext(WplywContext);

	// Initialize total deduction and percentage
	const [procent, setProcent] = useState(0);
	const [totals, setTotals] = useState(0);

	// Update totals on component mount and whenever wplyw changes
	useEffect(() => {
		const primaryDeduction =
			parseFloat(
				wplyw?.wplyw_data?.data?.msr_wplywy
					?.msr_wplywy_primary_deduction,
			) || 0;
		setTotals(primaryDeduction);
	}, [wplyw]);

	// Update percentage whenever wplyw or totals change
	useEffect(() => {
		const totalDeductions = Array.isArray(
			wplyw?.wplyw_data?.data?.msr_wplywy?.msr_persons,
		)
			? wplyw.wplyw_data.data.msr_wplywy.msr_persons.reduce(
					(sum, person) =>
						sum + (parseFloat(person?.msr_persons_deduction) || 0),
					0,
				)
			: 0;

		const totalDeductionsCents = Math.round(totalDeductions * 100);
		const totalsCents = Math.round(totals * 100);
		const calculatedProcent =
			totalsCents > 0
				? Math.round((totalDeductionsCents / totalsCents) * 100)
				: 0;
		if (totals == 0 && totalDeductions == 0) {
			setProcent(100);
		} else {
			setProcent(calculatedProcent);
		}
	}, [wplyw, totals]);

	// Calculate the remaining deduction balance
	const remainingDeductions =
		totals -
		(Array.isArray(wplyw?.wplyw_data?.data?.msr_wplywy?.msr_persons)
			? wplyw.wplyw_data.data.msr_wplywy.msr_persons.reduce(
					(sum, person) =>
						sum + (parseFloat(person?.msr_persons_deduction) || 0),
					0,
				)
			: 0);

	return (
		<div>
			<div
				style={{
					display: "flex",
					width: "100%",
					justifyContent: "space-between",
					padding: "10px",
					background: "#a5a5a5",
					borderRadius: "10px",
					position: "relative",
					overflow: "hidden",
					alignItems: "center",
					gap: "15px",
				}}
			>
				<div
					style={{
						width: `${Math.min(procent, 100)}%`, // Ensures it does not exceed 100%
						position: "absolute",
						height: "100%",
						background:
							procent >= 100
								? remainingDeductions < 0
									? "#DC0202"
									: "#52C41A"
								: "#DC0202", // Green if 100% or more, red if below 100%
						left: "0",
						top: "0",
						transition: "width 0.3s ease",
					}}
				></div>
				<div style={{ position: "relative", zIndex: 4, width: "100%" }}>
					<div style={{ color: "white", textAlign: "right" }}>
						Całkowita kwota odliczenia wstępnego
					</div>
					<div
						style={{
							fontWeight: 700,
							fontSize: "18px",
							color: "white",
							textAlign: "right",
						}}
					>
						{numberFormat(totals)} zł
					</div>
				</div>
				<div
					style={{
						height: "30px",
						width: "2px",
						background: "white",
						zIndex: "4",
					}}
				></div>
				<div style={{ position: "relative", zIndex: 4, width: "100%" }}>
					<div style={{ color: "white", textAlign: "left" }}>
						Rozpisana kwota odliczenia wstępnego
					</div>
					<div
						style={{
							fontWeight: 700,
							fontSize: "18px",
							color: "white",
							textAlign: "left",
						}}
					>
						{remainingDeductions < 0
							? `Kwota przekroczona o ${numberFormat(Math.abs(remainingDeductions).toFixed(2))} zł`
							: `${procent.toFixed(2)}%`}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProgressBarDeductions;
